// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"e72e6290","67":"10e0f78d","206":"eda3e2a6","288":"f54ec4b7","383":"0b0bd423","420":"1405d5d8","443":"369306c3","453":"88d07c20","563":"37b29134","706":"dff5fd61","945":"91749b95","958":"f5264487","963":"5f4dae14"}[chunkId] + ".chunk.js";
};